/** Слои z-index интерфейса владельца. Счётчик плавающих окон (`nextZIndex`) стартует с 1000 и
 *  растёт на каждую смену фокуса между окнами, поэтому база всех попапов antd (Tooltip, Dropdown,
 *  Select, DatePicker, Modal) — на порядки выше: иначе после сотен переключений окон (в том числе
 *  горячими клавишами) окно перекрыло бы свою же подсказку или выпадающий список. */
export const POPUP_Z_INDEX_BASE = 1_000_000;

/** Панель свёрнутых окон: над окнами, под любыми попапами и диалогами. */
export const TASKBAR_Z_INDEX = 100_000;
